/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { patchState, signalStoreFeature, withMethods, withState } from "@ngrx/signals";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { StoreCollection } from "src/app/enums";

export interface ColumnsState<K extends StoreCollection> {
  columns: Record<K, unknown[]>;
}

export function withColumns<T, K extends StoreCollection>(initialState: ColumnsState<K>) {
  return signalStoreFeature(
    withState<ColumnsState<K>>(initialState),
    withMethods(store => ({
      updateColumns(selectedColumns: T[], collection: K): void {
        const currentColumns = (store.columns()[collection] ?? []) as T[];
        const updatedSelectedColumns = selectedColumns;

        updatedSelectedColumns.forEach(column => {
          if (!currentColumns.includes(column)) currentColumns.push(column);
        });

        const columns = currentColumns.filter((column: T) => updatedSelectedColumns.includes(column)).sort((_: T) => 0);

        patchState(store, {
          columns: {
            ...store.columns(),
            [collection]: columns,
          },
        });
      },
      updateColumnsOrder(event: CdkDragDrop<string[]>, collection: K): void {
        const currentColumns = [...((store.columns()[collection] ?? []) as T[])];

        moveItemInArray(currentColumns, event.previousIndex, event.currentIndex);

        patchState(store, {
          columns: {
            ...store.columns(),
            [collection]: currentColumns,
          },
        });
      },
    })),
  );
}
